import React, { FC, SyntheticEvent, forwardRef, RefAttributes, useLayoutEffect, useRef } from 'react';
import { Button } from '../Button';

export interface ContactInfo {
  email?: string;
  phone?: string;
  timing?: string;
}

export interface ContactUsProps {
  showBack?: boolean;
  backButtonLabel?: string;
  backOnClick?: (e: SyntheticEvent) => void;
  className?: string;
  contact: ContactInfo;
}

export const ContactUs: FC<ContactUsProps & RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, ContactUsProps>(
  ({ showBack = false, backButtonLabel, backOnClick, contact, className }, ref) => {
    const refButton = useRef<HTMLButtonElement>();
    useLayoutEffect(() => {
      refButton && refButton.current && refButton.current.focus();
    }, []);
    return (
      <div className={`contact-us d-flex flex-column white-bg ${className}`} ref={ref}>
        {showBack && (
          <Button onClick={backOnClick} id="contact-us-back" type="button" variant="TERTIARY" ref={refButton}>
            {backButtonLabel}
          </Button>
        )}
        <div className="d-flex flex-column content">
          <span className="tel-label">{contact.phone}</span>
          <span>{contact.email}</span>
        </div>
      </div>
    );
  }
);

ContactUs.displayName = 'ContactUs';
export default ContactUs;
